import React from 'react'
import { createUseStyles } from 'react-jss';
import TextFieldV2 from '../../../atoms/TextFieldV2';
import { MODE } from '../../../../utils/constant';
import { titleModification } from '../../../../utils/helper';

interface CapacityDetailsFormTemplateProps {
    mode: string,
    formik: any;
}

const useStyles = createUseStyles((theme: any) => ({
    border: {
        border: `1px solid ${theme.palette.borderV2.tertiary.tertiary100}`
    },
    heading: {
        color: theme.palette.textV2.primary.primary900,
    },
    errorMessage: {
        color: theme.palette.action.danger,
    },
}));

const CapacityDetailsFormTemplate: React.FC<CapacityDetailsFormTemplateProps> = ({ mode, formik }) => {
    const classes = useStyles();

    return (
        <div className={`${classes.border} grid gap-y-4 p-4 rounded-xl`}>
        <div className={`${classes.heading} text-base font-medium`}>Capacity Details</div>
        <div className='grid grid-cols-4 gap-x-4'>
            <div className="grid gap-y-1">
                <TextFieldV2
                    label="Material Type"
                    placeholder='Enter Here'
                    {...formik.getFieldProps("materialHandle")}
                    error={formik.touched.materialHandle && Boolean(formik.errors.materialHandle)}
                    inputProps={{ readOnly: mode === MODE.VIEW, maxLength: 30 }}
                    onBlur={(event) => {
                        const newValue = titleModification(event.target.value);
                        formik.setFieldValue('materialHandle', newValue);
                    }}
                />
                {formik.errors.materialHandle && formik.touched.materialHandle && (
                    <div className={`${classes.errorMessage} text-xs`}>{formik.errors.materialHandle}</div>
                )}
            </div>

            <div className="grid gap-y-1">
                <TextFieldV2
                    label="Quality Standard"
                    placeholder='Enter Here'
                    {...formik.getFieldProps("qualityStandard")}
                    error={formik.touched.qualityStandard && Boolean(formik.errors.qualityStandard)}
                    inputProps={{ readOnly: mode === MODE.VIEW, maxLength: 30 }}
                    onBlur={(event) => {
                        const newValue = titleModification(event.target.value);
                        formik.setFieldValue('qualityStandard', newValue);
                    }}
                />
                {formik.errors.qualityStandard && formik.touched.qualityStandard && (
                    <div className={`${classes.errorMessage} text-xs`}>{formik.errors.qualityStandard}</div>
                )}
            </div>

            <div className="grid gap-y-1">
                <TextFieldV2
                    label="Material Grade"
                    placeholder='Enter Here'
                    {...formik.getFieldProps("materialGrade")}
                    error={formik.touched.materialGrade && Boolean(formik.errors.materialGrade)}
                    inputProps={{ readOnly: mode === MODE.VIEW, maxLength: 30 }}
                    onBlur={(event) => {
                        const newValue = titleModification(event.target.value);
                        formik.setFieldValue('materialGrade', newValue);
                    }}
                />
                {formik.errors.materialGrade && formik.touched.materialGrade && (
                    <div className={`${classes.errorMessage} text-xs`}>{formik.errors.materialGrade}</div>
                )}
            </div>
            <div className="grid gap-y-1">
                <TextFieldV2
                    label="Serviceability"
                    placeholder='Enter Here'
                    {...formik.getFieldProps("serviceability")}
                    error={formik.touched.serviceability && Boolean(formik.errors.serviceability)}
                    inputProps={{ readOnly: mode === MODE.VIEW, maxLength: 30 }}
                    onBlur={(event) => {
                        const newValue = titleModification(event.target.value);
                        formik.setFieldValue('serviceability', newValue);
                    }}
                />
                {formik.errors.serviceability && formik.touched.serviceability && (
                    <div className={`${classes.errorMessage} text-xs`}>{formik.errors.serviceability}</div>
                )}
            </div>
        </div>


        <div className={`${classes.border} grid gap-y-4 p-4 rounded-xl`}>
            <div className={`${classes.heading} text-base font-medium`}>Order Quantity</div>
            <div className='grid grid-cols-2 gap-x-4'>
                <div className="grid gap-y-1">
                    <TextFieldV2
                        label="Minimum Order Quantity"
                        placeholder='Enter Here'
                        {...formik.getFieldProps("minOrderQuantity")}
                        error={formik.touched.description && Boolean(formik.errors.minOrderQuantity)}
                        inputProps={{ readOnly: mode === MODE.VIEW }}
                        type='number'
                    />
                    {formik.errors.minOrderQuantity && formik.touched.minOrderQuantity && (
                        <div className={`${classes.errorMessage} text-xs`}>{formik.errors.minOrderQuantity}</div>
                    )}
                </div>
                <div className="grid gap-y-1">
                    <TextFieldV2
                        label="Maximum Order Quantity"
                        placeholder='Enter Here'
                        {...formik.getFieldProps("maxOrderQuantity")}
                        error={formik.touched.description && Boolean(formik.errors.maxOrderQuantity)}
                        inputProps={{ readOnly: mode === MODE.VIEW }}
                        type='number'
                    />
                    {formik.errors.maxOrderQuantity && formik.touched.maxOrderQuantity && (
                        <div className={`${classes.errorMessage} text-xs`}>{formik.errors.maxOrderQuantity}</div>
                    )}
                </div>
            </div>
        </div>
    </div>
    )
}

export default CapacityDetailsFormTemplate;